import {
  getBackProcedimentiTipi,
  getGetBackProcedimentiTipiQueryOptions,
  useGetBackProcedimentiTipi,
} from '@framework/api-client/api/backoffice/procedimenti/procedimenti.ts';
import { type GetBackProcedimentiTipiSettore } from '@framework/api-client/api/backoffice/schemas/getBackProcedimentiTipiSettore.ts';
import { GetBackProcedimentiTipiTipologia } from '@framework/api-client/api/backoffice/schemas/getBackProcedimentiTipiTipologia.ts';
import { type TipologiaProcedimentoDTO } from '@framework/api-client/api/backoffice/schemas/tipologiaProcedimentoDTO.ts';
import { createAsyncSelectChipValue } from '@framework/form/inputs/AsyncSelectChipValue.tsx';
import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { SearchRowAlert } from '@framework/ui/components/search/component/SearchRowAlert.tsx';

function mapOptions(procedures: TipologiaProcedimentoDTO[] | null | undefined) {
  if (!procedures) return [];
  return procedures
    .map(procedure => ({
      value: procedure.id!,
      label: procedure.nomeTipo!,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export interface IProcedureAsyncSelectInputProps {
  disabled?: boolean;
  name: string;
  placement?: ISelectInputProps['placement'];
  procedureSector?: GetBackProcedimentiTipiSettore;
  type?: GetBackProcedimentiTipiTipologia;
  size?: 'small' | 'middle' | 'large';
}

export function ProcedureAsyncSelectInput(
  props: IProcedureAsyncSelectInputProps,
) {
  const { disabled, name, size = 'middle' } = props;

  const procedures = useGetBackProcedimentiTipi({
    settore: props.procedureSector,
    tipologia: props.type,
  });

  if (procedures.isError) {
    return (
      <SearchRowAlert message="Impossibile recuperare la lista dei procedimenti" />
    );
  }

  return (
    <SelectInput
      size={size}
      name={name}
      placeholder={
        props.type == GetBackProcedimentiTipiTipologia.PRATICA
          ? 'Pratica...'
          : 'Procedimento...'
      }
      popupMatchSelectWidth={false}
      placement={props.placement}
      allowClear
      loading={procedures.isLoading}
      options={mapOptions(procedures.data?.data)}
      disabled={disabled}
      searchable
    />
  );
}

/** `renderValue` per il chip FilterBar: risolve l'id del tipo procedimento. */
export const procedureChipValue = createAsyncSelectChipValue({
  queryFn: getBackProcedimentiTipi,
  queryOptions: getGetBackProcedimentiTipiQueryOptions,
  asOption: (procedure: TipologiaProcedimentoDTO) => ({
    value: procedure.id!,
    label: procedure.nomeTipo!,
  }),
});
